module.exports = __webpack_public_path__ + "static/img/2016120817393507.545edc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2016120817393507.png
// module id = 4y2O
// module chunks = 1